import { render, staticRenderFns } from "./OsGlobalDialogs.vue?vue&type=template&id=26278b3e&scoped=true"
import script from "./OsGlobalDialogs.vue?vue&type=script&lang=ts"
export * from "./OsGlobalDialogs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26278b3e",
  null
  
)

export default component.exports